<template>
  <div class="rb-ob-form rb-match-page rb-book-page rb-pay-page rb-consent-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.readyLockTitle') }}</h1>
    </header>
    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ $t('intake.readyLockBody') }}</p>
    </div>
    <ul
        v-if="blockers.length"
        class="rb-pay-summary"
        :aria-label="$t('intake.readyLockSummaryAria')"
    >
      <li v-for="code in blockers" :key="code">
        <span class="rb-pay-summary-k">{{ blockerLabel(code) }}</span>
      </li>
    </ul>
    <div class="rb-ob-actions">
      <button
          v-if="needsConsent"
          class="rb-ob-submit"
          type="button"
          @click="completeConsent"
      >
        {{ $t('intake.readyLockCta') }}
      </button>
      <button
          class="rb-ob-submit"
          :class="needsConsent ? 'rb-ob-submit-secondary' : ''"
          type="button"
          @click="goHome"
      >
        {{ $t('intake.readyLockHome') }}
      </button>
      <p class="rb-ob-status">{{ status }}</p>
    </div>
  </div>
</template>
<script>
import {clientError} from '@/intake/clientMessages'
import {resolveSessionPreparation, sessionPreparationReady} from '@/intake/sessionPreparation'

export default {
  name: 'MatchReadyLockStep',
  data() {
    return {care: null, session: null, status: '', loading: true, generation: 0, resolvedQueryKey: null}
  },
  computed: {
    blockers() {
      return (this.care
        && this.care.first_session_operational_readiness
        && this.care.first_session_operational_readiness.blocker_codes)
        || []
    },
    needsConsent() {
      return this.blockers.some((code) => [
        'CONSENT_NOT_COMPLETE',
        'CONSENT_TEMPLATE_NOT_APPROVED',
      ].indexOf(code) !== -1)
    },
  },
  mounted() {
    return this.bootstrap()
  },
  watch: {'$route.query': {deep: true, handler() { return this.bootstrap() }}},
  beforeDestroy() { this.generation += 1 },
  methods: {
    async bootstrap() {
      const generation = ++this.generation
      const query = {...(this.$route.query || {})}
      const queryKey = JSON.stringify(query)
      const current = () => generation === this.generation && queryKey === JSON.stringify(this.$route.query || {})
      this.loading = true; this.care = null; this.session = null; this.status = ''; this.resolvedQueryKey = null
      try {
        const context = await resolveSessionPreparation(query)
        if (!current()) return
        this.care = context.care; this.session = context.session
        this.resolvedQueryKey = queryKey
        if (sessionPreparationReady(context)) {
          this.$router.replace({name: 'intakeReadyOk', params: {lang: this.$route.params.lang || 'fa'},
            query: {id: String(context.session.id)}})
        }
      } catch (error) {
        if (current()) this.status = clientError(error, this.$route.params.lang || 'fa')
      } finally {
        if (current()) this.loading = false
      }
    },
    completeConsent() {
      if (this.loading || this.resolvedQueryKey !== JSON.stringify(this.$route.query || {}) || !this.care || !this.needsConsent || !this.session) return
      this.$router.push({
        name: 'intakeConsent',
        params: {lang: this.$route.params.lang || 'fa'},
        query: {id: String(this.session.id)},
      })
    },
    goHome() {
      this.$router.push({
        name: 'intakeClientHome',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
    blockerLabel(code) {
      const fa = (this.$route.params.lang || 'fa') === 'fa'
      const labels = {
        CONSENT_NOT_COMPLETE: fa ? 'رضایت‌نامه کامل نشده' : 'Consent is not complete',
        CONSENT_TEMPLATE_NOT_APPROVED: fa ? 'نسخهٔ رضایت‌نامه تأیید نشده' : 'Consent template is not approved',
        SESSION_ACCESS_NOT_AUTHORIZED: fa ? 'دسترسی جلسه مجاز نیست' : 'Session access is not authorized',
        SESSION_PROVIDER_NOT_READY: fa ? 'اتاق جلسه آماده نیست' : 'Session room is not ready',
        SESSION_SLOT_NOT_READY: fa ? 'زمان جلسه آماده نیست' : 'Session slot is not ready',
        PAYMENT_ENTITLEMENT_NOT_READY: fa ? 'پرداخت آماده نیست' : 'Payment is not ready',
        NOTIFICATION_NOT_DELIVERED: fa ? 'اعلان جلسه ثبت نشده' : 'Session notification is not recorded',
        SCOPED_HANDOFF_NOT_READY: fa ? 'تحویل محدودهٔ جلسه آماده نیست' : 'Scoped handoff is not ready',
        PARTICIPANT_AUTHORITY_NOT_READY: fa ? 'صلاحیت شرکت‌کننده آماده نیست' : 'Participant authority is not ready',
      }
      return labels[code] || (fa ? 'یکی از مراحل آمادگی جلسه هنوز کامل نشده است.' : 'A session preparation step is not complete yet.')
    },
  },
}
</script>
